import * as React from 'react'
import { Navigate, useParams } from 'react-router-dom'
import { Loader } from '@/ui'
import { useQueryCurrentUserDriverId } from '@/lib/api/company/drivers'
import { NoPermissionScreen } from '@/modules/shared/components/NoPermission'
import { DRIVER_ROUTES } from '../routes-typed'

type Props = {
  companyId: string
  /** Bez dzieci zawsze przekierowuje na aktywności własnego kierowcy. */
  children?: React.ReactNode
}

/** Kierowca ogląda tylko siebie: inny kierowca albo widok grupowy kończy się na jego aktywnościach. */
export const OwnDriverGate: React.FC<Props> = ({ companyId, children }) => {
  const { driverId } = useParams<{ driverId?: string }>()
  const { data: ownDriverId, isLoading } = useQueryCurrentUserDriverId({
    companyId,
  })

  if (isLoading) return <Loader fill />
  if (!ownDriverId) return <NoPermissionScreen />
  if (children && Number(driverId) === ownDriverId) return <>{children}</>

  return (
    <Navigate
      to={DRIVER_ROUTES.activities.buildPath({
        companyId,
        driverId: ownDriverId,
      })}
      replace
    />
  )
}
